import { useRouter } from 'next/router';

import { useUserProfile } from '@hooks/user';
import { useEffect, useState } from 'react';

export default function useCreatorSetupButtonLabel() {
  const router = useRouter();
  const [isDesktopView, setIsDesktopView] = useState<boolean>();
  const { userProfile, isSignedOut } = useUserProfile();

  const isCreator = !isSignedOut && userProfile?.role === 'CREATOR';
  const isStartPage = router.pathname === '/start';

  const startCreatorButtonLabel =
    isStartPage || !isDesktopView
      ? '크리에이터 계정 만들기'
      : '크리에이터 시작하기';
  const creatorStudioButtonLabel = '크리에이터 스튜디오';

  const creatorAccountButtonLabel = isCreator
    ? creatorStudioButtonLabel
    : startCreatorButtonLabel;

  const setViewport = () => {
    const viewportWidth = window.innerWidth;
    setIsDesktopView(viewportWidth > 768);
  };

  useEffect(() => {
    setViewport();
    window.addEventListener('resize', setViewport);

    return () => {
      window.removeEventListener('resize', setViewport);
    };
  }, []);

  return creatorAccountButtonLabel;
}
